
import { mapState, mapActions, mapGetters, mapMutations } from 'vuex';
import MediaTab from './components/MediaTab';
import ReviewMediaSectionPc from './components/ReviewMediaSectionPc';
import ZoomedMediumPc from './components/ZoomedMediumPc';

export default {
  i18nComponentKey: 'ProductReviewsMediaCollage.ProductReviewsMediaCollagePc',
  name: 'ProductReviewsMediaCollagePc',
  components: { MediaTab, ReviewMediaSectionPc, ZoomedMediumPc },
  data() {
    return {
      selectedReview: null,
      selectedMediaPosition: 1,
      isZoomedIn: false,
      lastSelectedReview: null,
      lastSelectedMediaPosition: 1
    };
  },
  computed: {
    ...mapState('productMediaReviewCollage', [
      'isLoadingMediaReviewCollage',
      'pagy',
      'totalMediaCount',
      'activeTab'
    ]),
    ...mapGetters('productMediaReviewCollage', ['reviewMedia']),
    ...mapState('window', ['windowService']),
    ...mapState('widget', ['reviewId']),
    ...mapState('review', ['mediaIndex']),
    ...mapState('reviewSettings', ['reviewSettings']),
    ...mapGetters('review', ['isManagerReview']),
    ...mapGetters('widget', ['nthReviewWidgetStylePopup']),
    ...mapGetters('reviewSettings', [
      'isVideoUploadable',
      'isAuthorDisplayTypeUserGrade'
    ]),
    defaultResourceParams() {
      return {
        fields: [
          'reviews.evaluation_properties',
          'reviews.customer_properties',
          'reviews.display_user_options',
          this.isAuthorDisplayTypeUserGrade ? 'reviews.brand_user_grade' : '',
          this.reviewSettings.always_show_comments ? 'reviews.comments' : '',
          this.nthReviewWidgetStylePopup ? 'reviews.with_parent_reviews' : ''
        ]
          .filter(v => v)
          .join(',')
      };
    },
    lastSelectedMedium() {
      return this.reviewMedia.find(
        media =>
          media.review.id === this.lastSelectedReview?.id &&
          media.media_position === this.lastSelectedMediaPosition
      );
    },
    initialMedium() {
      if (!this.reviewId) return;

      let mediaIndex = parseInt(this.mediaIndex);
      if (isNaN(mediaIndex)) mediaIndex = 0;

      return this.reviewMedia.find(
        media =>
          media.review.id === parseInt(this.reviewId) &&
          media.media_position === mediaIndex
      );
    },
    infiniteScrollObserverKey() {
      return `${this.activeTab}-${this.pagy.next}`;
    }
  },
  watch: {
    reviewMedia() {
      this.initializeSelectedReview();
    }
  },
  mounted() {
    this.SET_REVIEWS_SOURCE_NAME_FOR_LIKE('productMediaReviewCollage');
    this.SET_REVIEWS_SOURCE_NAME_FOR_COMMENT('productMediaReviewCollage');
    this.fetchResource({ init: true });
  },
  methods: {
    ...mapActions('productMediaReviewCollage', [
      'fetchProductMediaReviewCollage'
    ]),
    ...mapMutations('like', {
      SET_REVIEWS_SOURCE_NAME_FOR_LIKE: 'SET_REVIEWS_SOURCE_NAME'
    }),
    ...mapMutations('comment', {
      SET_REVIEWS_SOURCE_NAME_FOR_COMMENT: 'SET_REVIEWS_SOURCE_NAME'
    }),
    ...mapMutations('productMediaReviewCollage', ['SET_ACTIVE_TAB']),
    fetchResource(params) {
      return this.fetchProductMediaReviewCollage({
        ...params,
        ...this.defaultResourceParams
      });
    },
    onIntersect() {
      if (this.isLoadingMediaReviewCollage || !this.pagy.next) return;

      const params = { page: this.pagy.next };
      if (this.activeTab === 'video') params.with_video = true;
      this.fetchResource(params);
    },
    onClickDimmed() {
      if (this.isZoomedIn) this.isZoomedIn = false;
      else this.windowService.closeFullscreenPopup();
    },
    onTabChange(tab) {
      this.SET_ACTIVE_TAB(tab);
      const params = { init: true };
      if (tab === 'video') params.with_video = true;
      this.fetchResource(params);
    },
    onClickMedia(media) {
      this.setSelectedReviewMedium(media);
      this.setLastSelectedReviewMedium(media);
    },
    setSelectedReviewMedium(media) {
      const { review, media_position } = media;
      this.selectedReview = review;
      this.selectedMediaPosition = media_position;
      // 모아보기 팝업 사진 이동 시 번역(googleTranslator) 재실행을 위한 이벤트 발신 (https://app.asana.com/1/6477513906631/project/1203851048809308/task/1217385793075466)
      // TODO: 번역 기능 개편 이후 삭제 필요
      document.dispatchEvent(new Event('history:updated'));
    },
    setLastSelectedReviewMedium(media) {
      const { review, media_position } = media;
      this.lastSelectedReview = review;
      this.lastSelectedMediaPosition = media_position;
    },
    initializeSelectedReview() {
      if (this.reviewMedia.length === 0) return;

      const media =
        this.lastSelectedMedium || this.initialMedium || this.reviewMedia[0];
      this.setSelectedReviewMedium(media);
      this.setLastSelectedReviewMedium(media);
    },
    isSelectedMedium(media) {
      return (
        this.selectedReview?.id === media.review.id &&
        this.selectedMediaPosition === media.media_position
      );
    }
  }
};
